import React from "react";
import Select from "react-select";

const DefaultSelect = (props) => {
	const selectStyle = {
		container: (provided, state) => ({
			...provided,
			marginRight: 0,
			width: "100%",
			float: "right",
			...props.customStyle,
		}),
		option: (provided, state) => ({
			...provided,
			fontSize: "13px",
		}),
		menu: (provided) => ({ ...provided, zIndex: 9999 }),
		menuList: (provided, state) => ({
			...provided,
			maxHeight: "500px",
			color: "black",
			textAlign: "left",
		}),
		groupHeading: (provided, state) => ({
			...provided,
			fontSize: "13px",
			color: "#a4aaaa",
			borderTop: "#a4aaaa 1px solid",
		}),
		singleValue: (provided, state) => {
			const fontSize = "13px";
			return { ...provided, fontSize };
		},
		valueContainer: (provided, state) => {
			return { ...provided, ...props.valueContainer };
		},
		input: (provided, state) => {
			return { ...provided, ...props.input };
		},
	};

	return (
		<Select
			{...props}
			styles={selectStyle}
			options={props.options}
			isMulti={props.isMulti}
			defaultValue={props.defaultValue}
			value={props.value}
			onChange={props.onChange}
			isLoading={props.isLoading}
			isDisabled={props.isDisabled}
		/>
	);
};

export default DefaultSelect;
